export default "__VITE_ASSET__B58kKzg4__"